import "./ImageStyles.css";

function ImageStyles(props) {
  return <div className="custom-image">{props.children}</div>;
}

export default ImageStyles;
